import * as React from 'react';
import classNames from 'classnames';
import { Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';
import { NavigationUserItem, navigationUserData, navigationAdminData } from 'src/api/models/Navigation/NavigationUser';
import { SelectLanguage } from '../../Localize';

import './UserNavigation.scss';
import { dynamicTitles, dynamicTitlesKey, GlobalPrivateState } from 'src/api';
import { userIsAdmin } from '../../Admin/utils';

export interface UserNavigationProps {
  dispatch: any;
  location: RouterState['location'];
  user: GlobalPrivateState['user'];
}

export class UserNavigationPartial extends React.Component<UserNavigationProps, any> {
  public render() {
    const { location, user } = this.props;
    const isUserAdmin = user.result && userIsAdmin(user.result);
    const navigation = isUserAdmin ? navigationAdminData() : navigationUserData();

    return (
      <div className="partial-user-navigation">
        <Nav className="d-block pb-4 text-center">
          {Object.keys(navigation).map((itemKey, index) => {
            const key = `configuration_navigation_${itemKey}_${index}`;
            const item = navigation[itemKey] as NavigationUserItem;
            const isActive = location.pathname === item.to ? true : false;
            return(
              <NavItem 
                key={key}
                className={classNames({'is-active' : isActive})}
                active={isActive}
              >
                <Link
                  className={classNames({'is-active' : isActive}, 'pt-3 pb-3 d-block')}
                  onClick={() => this.handleClick(item, isActive)}
                  title={item.title}
                  to={item.to} 
                >
                  {item.name}
                </Link>
              </NavItem>
            );
          })}
          {!isUserAdmin && (
            <NavItem>
              <SelectLanguage />
            </NavItem>
          )}
        </Nav>
      </div>
    );
  }
  private handleClick(item: NavigationUserItem, active: boolean) {
    if (active) {
      return;
    }
    this.props.dispatch(dynamicTitles.add({
      key: dynamicTitlesKey.dashboard,
      value: item.title
    }));
  }
}

export const UserNavigation = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
  user: state.user,
}))(UserNavigationPartial);

export default UserNavigation;